import { useWindowSize } from "usehooks-ts";

export type PageSize = 'default' | 'middle' | 'small'

export default (): PageSize => {
	const { width } = useWindowSize()

	return width > 1768 ? 'default' : width > 1380 ? 'middle' : 'small';
}